import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IPermitTypeFieldsFragmentFragment = {
  id?: any | null
  parentId?: any | null
  type?: Types.PermitFieldType | null
  caption: string
  isMandatory?: boolean | null
  isShown?: boolean | null
  isMultiple?: boolean | null
  canEditIsShown: boolean
  canEditIsMandatory: boolean
  allowPreciseLocation?: boolean | null
  isUserStampEnabled?: boolean | null
  isLBSLogicEnabled?: boolean | null
  allowSelectExisting?: boolean | null
  allowCreateNew?: boolean | null
  selectOptions?: Array<string | null> | null
  isUsedInMaterial?: boolean | null
  mediaView?: Types.MediaViewType | null
  filterOptions?: Array<{
    propertyPath?: string | null
    operator: Types.OperatorType
    values?: Array<string | null> | null
    fieldId?: string | null
    fieldValues?: Array<string | null> | null
  } | null> | null
  instructions?: {
    list?: Array<string | null> | null
    listType?: string | null
  } | null
  checklist?: {
    listType?: string | null
    list?: Array<{
      id?: any | null
      text?: string | null
      questionnaireType?: string | null
    } | null> | null
  } | null
  inlineMediaItems?: Array<{
    fileName: string
    size: string
    url: string
  } | null> | null
  defaultOptions?: {
    sortOption?: string | null
    sortDirection?: Types.SortDirection | null
    groupOption?: string | null
    filterOptions?: Array<{
      type?: string | null
      values?: Array<string | null> | null
    } | null> | null
  } | null
}

export type IGetDefaultPermitTypesQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type IGetDefaultPermitTypesQuery = {
  defaultPermitTypes?: {
    data: Array<{
      id?: any | null
      orderIndex: number
      name?: string | null
      isEnabled: boolean
      categoryId?: any | null
      type: string
      isAutoActivationEnabled?: boolean | null
      autoEndStepIds?: Array<any | null> | null
      isWorkflowTitleMandatory?: boolean | null
      iconName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      inspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      bookingDeadlineOptions?: {
        deadlineInterval?: any | null
        blockType?: Types.BlockTypeEnum | null
      } | null
      workflowSteps?: Array<{
        id?: any | null
        type: Types.WorkflowStepType
        workflowRuleIds: Array<any | null>
        notificationFieldIds: Array<any | null>
        fields: Array<{
          id?: any | null
          parentId?: any | null
          type?: Types.PermitFieldType | null
          caption: string
          isMandatory?: boolean | null
          isShown?: boolean | null
          isMultiple?: boolean | null
          canEditIsShown: boolean
          canEditIsMandatory: boolean
          allowPreciseLocation?: boolean | null
          isUserStampEnabled?: boolean | null
          isLBSLogicEnabled?: boolean | null
          allowSelectExisting?: boolean | null
          allowCreateNew?: boolean | null
          selectOptions?: Array<string | null> | null
          isUsedInMaterial?: boolean | null
          mediaView?: Types.MediaViewType | null
          filterOptions?: Array<{
            propertyPath?: string | null
            operator: Types.OperatorType
            values?: Array<string | null> | null
            fieldId?: string | null
            fieldValues?: Array<string | null> | null
          } | null> | null
          instructions?: {
            list?: Array<string | null> | null
            listType?: string | null
          } | null
          checklist?: {
            listType?: string | null
            list?: Array<{
              id?: any | null
              text?: string | null
              questionnaireType?: string | null
            } | null> | null
          } | null
          inlineMediaItems?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
          defaultOptions?: {
            sortOption?: string | null
            sortDirection?: Types.SortDirection | null
            groupOption?: string | null
            filterOptions?: Array<{
              type?: string | null
              values?: Array<string | null> | null
            } | null> | null
          } | null
        } | null>
        conditionalFields: Array<{
          fieldId: any
          key: string
          values: Array<{
            id?: any | null
            parentId?: any | null
            type?: Types.PermitFieldType | null
            caption: string
            isMandatory?: boolean | null
            isShown?: boolean | null
            isMultiple?: boolean | null
            canEditIsShown: boolean
            canEditIsMandatory: boolean
            allowPreciseLocation?: boolean | null
            isUserStampEnabled?: boolean | null
            isLBSLogicEnabled?: boolean | null
            allowSelectExisting?: boolean | null
            allowCreateNew?: boolean | null
            selectOptions?: Array<string | null> | null
            isUsedInMaterial?: boolean | null
            mediaView?: Types.MediaViewType | null
            filterOptions?: Array<{
              propertyPath?: string | null
              operator: Types.OperatorType
              values?: Array<string | null> | null
              fieldId?: string | null
              fieldValues?: Array<string | null> | null
            } | null> | null
            instructions?: {
              list?: Array<string | null> | null
              listType?: string | null
            } | null
            checklist?: {
              listType?: string | null
              list?: Array<{
                id?: any | null
                text?: string | null
                questionnaireType?: string | null
              } | null> | null
            } | null
            inlineMediaItems?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
            defaultOptions?: {
              sortOption?: string | null
              sortDirection?: Types.SortDirection | null
              groupOption?: string | null
              filterOptions?: Array<{
                type?: string | null
                values?: Array<string | null> | null
              } | null> | null
            } | null
          } | null>
        } | null>
        actions?: Array<
          | {
              locationFieldIds?: Array<any | null> | null
              type?: Types.PermitActionType | null
            }
          | {
              type?: Types.PermitActionType | null
              locationFieldsMap?: Array<{
                fieldId: any
                specifiedPermitTypes?: Array<string | null> | null
                isDisabled?: boolean | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      recurringOptions?: {
        isEnabled?: boolean | null
        maxDuration?: number | null
      } | null
      maxDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
      defaultDurationOptions?: {
        isEnabled?: boolean | null
        durationType?: Types.WorkflowDurationType | null
        durationUnit?: Types.WorkflowDurationUnit | null
        duration?: number | null
      } | null
    }>
  } | null
}

export const PermitTypeFieldsFragmentFragmentDoc = gql`
  fragment PermitTypeFieldsFragment on PermitTypeField {
    id
    parentId
    type
    caption
    isMandatory
    isShown
    isMultiple
    canEditIsShown
    canEditIsMandatory
    allowPreciseLocation
    isUserStampEnabled
    isLBSLogicEnabled
    allowSelectExisting
    allowCreateNew
    filterOptions {
      propertyPath
      operator
      values
      fieldId
      fieldValues
    }
    selectOptions
    instructions {
      list
      listType
    }
    checklist {
      list {
        id
        text
        questionnaireType
      }
      listType
    }
    isUsedInMaterial
    inlineMediaItems {
      fileName
      size
      url
    }
    mediaView
    defaultOptions {
      sortOption
      sortDirection
      groupOption
      filterOptions {
        type
        values
      }
    }
  }
`
export const GetDefaultPermitTypesDocument = gql`
  query GetDefaultPermitTypes($limit: Int) {
    defaultPermitTypes(limit: $limit) {
      data {
        id
        orderIndex
        name
        isEnabled
        categoryId
        inspectionOptions {
          deadlineTime
          inspectionFrequency
          inspectionFrequencyType
          selectedDaysToRepeat
        }
        bookingDeadlineOptions {
          deadlineInterval
          blockType
        }
        type
        isAutoActivationEnabled
        autoEndStepIds
        isWorkflowTitleMandatory
        workflowSteps {
          id
          type
          fields {
            ...PermitTypeFieldsFragment
          }
          conditionalFields {
            fieldId
            key
            values {
              ...PermitTypeFieldsFragment
            }
          }
          workflowRuleIds
          notificationFieldIds
          actions {
            type
            ... on StartClosureAction {
              locationFieldsMap {
                fieldId
                specifiedPermitTypes
                isDisabled
              }
            }
            ... on EndClosureAction {
              locationFieldIds
            }
          }
        }
        recurringOptions {
          isEnabled
          maxDuration
        }
        maxDurationOptions {
          isEnabled
          durationType
          durationUnit
          duration
        }
        defaultDurationOptions {
          isEnabled
          durationType
          durationUnit
          duration
        }
        iconName
        createdAt
        updatedAt
      }
    }
  }
  ${PermitTypeFieldsFragmentFragmentDoc}
`

/**
 * __useGetDefaultPermitTypesQuery__
 *
 * To run a query within a React component, call `useGetDefaultPermitTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultPermitTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultPermitTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDefaultPermitTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IGetDefaultPermitTypesQuery,
    IGetDefaultPermitTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetDefaultPermitTypesQuery,
    IGetDefaultPermitTypesQueryVariables
  >(GetDefaultPermitTypesDocument, options)
}
export function useGetDefaultPermitTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetDefaultPermitTypesQuery,
    IGetDefaultPermitTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetDefaultPermitTypesQuery,
    IGetDefaultPermitTypesQueryVariables
  >(GetDefaultPermitTypesDocument, options)
}
export type GetDefaultPermitTypesQueryHookResult = ReturnType<
  typeof useGetDefaultPermitTypesQuery
>
export type GetDefaultPermitTypesLazyQueryHookResult = ReturnType<
  typeof useGetDefaultPermitTypesLazyQuery
>
export type GetDefaultPermitTypesQueryResult = Apollo.QueryResult<
  IGetDefaultPermitTypesQuery,
  IGetDefaultPermitTypesQueryVariables
>
